import React from 'react';
import PropTypes from 'prop-types';
import Option from './option';
import { AvatarOptionsWrapper } from './styled';

const AvatarOptions = ({ options, name, config, withBackground, withTop }) => {
  return (
    <AvatarOptionsWrapper
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
    >
      {options.map((option, index) => {
        const optionConfig = withTop ? option.config : { ...option.config, top: null };

        return (
          <Option
            key={index}
            onClick={option.onClick}
            config={optionConfig}
            isSelected={name && option.config[name] === config[name]}
            currentConfig={config}
            withBackground={withBackground}
            withTop={withTop}
          />
        );
      })}
    </AvatarOptionsWrapper>
  );
};

AvatarOptions.propTypes = {
  name: PropTypes.string,
  options: PropTypes.array,
  config: PropTypes.object,
  withBackground: PropTypes.bool,
  withTop: PropTypes.bool
};

export default AvatarOptions;
